import * as AutoKana from 'vanilla-autokana'
import { beforeUnloadDialog } from '@pc/components/BeforeUnloadDialog'
import { displayCategoryTextarea } from '@pc/components/Companies/DisplayCategoryTextarea'
import { zipToAddress } from '@pc/components/ZipToAddress'

document.addEventListener('DOMContentLoaded', () => {
  // フリガナ補完
  const companyName = document.getElementById('company_ask_company_name') as HTMLInputElement
  const companyNameRuby = document.getElementById('company_ask_company_name_ruby') as HTMLInputElement
  if (companyName !== null && companyNameRuby !== null) {
    AutoKana.bind(`#${companyName.id}`, `#${companyNameRuby.id}`, { katakana: true })
  }

  // 「問い合わせカテゴリ」のその他を選択した時のテキストエリア(企業向け)
  displayCategoryTextarea()

  // 離脱防止・submit時ダイアログ
  beforeUnloadDialog('js-ask-form', true)

  // 住所補完
  const getAddressButton = document.getElementById('js-get-address')
  if (getAddressButton !== null) {
    getAddressButton.addEventListener('click', (e) => {
      e.preventDefault()
      zipToAddress()
    })
  }
})
